import { useCallback, useEffect, useRef, useState } from "react";

export const useSmoothLoading = (minDuration: number = 400) => {
  const [isLoading, setIsLoading] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const startTimeRef = useRef<number>(0);

  const startLoading = useCallback(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    startTimeRef.current = Date.now();
    setIsLoading(true);
  }, []);

  const stopLoading = useCallback(() => {
    const elapsed = Date.now() - startTimeRef.current;

    if (elapsed >= minDuration) {
      setIsLoading(false);
    } else {
      timeoutRef.current = setTimeout(() => {
        setIsLoading(false);
      }, minDuration - elapsed);
    }
  }, [minDuration]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return { isLoading, startLoading, stopLoading };
};
